import { GridSortFnType } from '../../enums';
import { sortByNumber, sortByAlphabet, sortByDate } from '..';

class GridSortingFnsFactory {
  static getSortFnsByType(type) {
    return this.#sortOptionsByType(type);
  }

  static #sortOptionsByType(type) {
    switch (type) {
      case GridSortFnType.Number:
        return sortByNumber;
      case GridSortFnType.Date:
        return sortByDate;
      case GridSortFnType.Alphabet:
      default:
        return sortByAlphabet;
    }
  }
}

export default GridSortingFnsFactory;
